module.exports = __webpack_public_path__ + "img/bg-green-valley.b7231934.jpg";